/* js/pages/HomePage.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Header from '../components/Header.svelte';
import { db } from '../Db';
import { Ripple } from 'svelte-mui';
import HyperButton from '../components/HyperButton.svelte';
import HyperButtonVignette from '../components/HyperButtonVignette.svelte';
import ShareButton from '../components/ShareButton.svelte';
import { appRouter } from '../appRouter';
import computeUrl from '../url';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (56:4) {#each parcoursArray as parcours}
function create_each_block(ctx) {
	let div1;
	let img;
	let img_src_value;
	let t0;
	let div0;
	let t1_value = /*parcours*/ ctx[4].title + "";
	let t1;
	let t2;
	let mounted;
	let dispose;

	function click_handler_1() {
		return /*click_handler_1*/ ctx[3](/*parcours*/ ctx[4]);
	}

	return {
		c() {
			div1 = element("div");
			img = element("img");
			t0 = space();
			div0 = element("div");
			t1 = text(t1_value);
			t2 = space();
			attr(img, "class", "cover-event svelte-1odvnbf");
			if (!src_url_equal(img.src, img_src_value = /*parcours*/ ctx[4].media.button_image)) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(div0, "class", "description svelte-1odvnbf");
			attr(div1, "class", "grid-element event-card svelte-1odvnbf");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, img);
			append(div1, t0);
			append(div1, div0);
			append(div0, t1);
			append(div1, t2);

			if (!mounted) {
				dispose = listen(div1, "click", click_handler_1);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div1;
	let div0;
	let ripple;
	let t1;
	let img0;
	let img0_src_value;
	let t2;
	let sharebutton;
	let t3;
	let div11;
	let div2;
	let t4;
	let div3;
	let t6;
	let div4;
	let t10;
	let h2;
	let t12;
	let br2;
	let t13;
	let div6;
	let div5;
	let t14;
	let html_tag;
	let raw_value = /*index*/ ctx[0].html + "";
	let t15;
	let br3;
	let br4;
	let br5;
	let t16;
	let div9;
	let t18;
	let div10;
	let current;
	let mounted;
	let dispose;
	header = new Header({ props: { title: "hypercity" } });
	ripple = new Ripple({ props: { center: true } });
	sharebutton = new ShareButton({ props: { url: computeUrl() } });
	let each_value = /*parcoursArray*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div1 = element("div");
			div0 = element("div");
			create_component(ripple.$$.fragment);
			t1 = space();
			img0 = element("img");
			t2 = space();
			create_component(sharebutton.$$.fragment);
			t3 = space();
			div11 = element("div");
			div2 = element("div");
			t4 = space();
			div3 = element("div");
			div3.textContent = "hypercity";
			t6 = space();
			div4 = element("div");
			div4.innerHTML = `Histoire(s) <br/>et imaginaires<br/>de nos rues`;
			t10 = space();
			h2 = element("h2");
			h2.textContent = "Parcours actifs";
			t12 = space();
			br2 = element("br");
			t13 = space();
			div6 = element("div");
			div5 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t14 = space();
			html_tag = new HtmlTag();
			t15 = space();
			br3 = element("br");
			br4 = element("br");
			br5 = element("br");
			t16 = space();
			div9 = element("div");

			div9.innerHTML = `<div class="logo-bm svelte-1odvnbf"><img class="logo svelte-1odvnbf" src="/images/logo_bm.png" alt=""/></div> 

            <div class="logo-ville svelte-1odvnbf"><img class="logo svelte-1odvnbf" src="/images/logo_ville.png" alt=""/></div>`;

			t18 = space();
			div10 = element("div");
			if (!src_url_equal(img0.src, img0_src_value = "/_icons/info.svg")) attr(img0, "src", img0_src_value);
			attr(div0, "class", "fab-button small bottom-left box-shadow");
			attr(div1, "class", "footer gradient");
			attr(div2, "class", "headspacer");
			attr(div3, "class", "main-title");
			attr(div4, "class", "main-sub");
			attr(div5, "class", "grid-container grid-container--fill");
			attr(div6, "class", "grid-group-wrapper");
			html_tag.a = t15;
			attr(div9, "class", "home-footer svelte-1odvnbf");
			attr(div10, "class", "footerspacer");
			attr(div11, "class", "column");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(ripple, div0, null);
			append(div0, t1);
			append(div0, img0);
			append(div1, t2);
			mount_component(sharebutton, div1, null);
			insert(target, t3, anchor);
			insert(target, div11, anchor);
			append(div11, div2);
			append(div11, t4);
			append(div11, div3);
			append(div11, t6);
			append(div11, div4);
			append(div11, t10);
			append(div11, h2);
			append(div11, t12);
			append(div11, br2);
			append(div11, t13);
			append(div11, div6);
			append(div6, div5);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div5, null);
			}

			append(div11, t14);
			html_tag.m(raw_value, div11);
			append(div11, t15);
			append(div11, br3);
			append(div11, br4);
			append(div11, br5);
			append(div11, t16);
			append(div11, div9);
			append(div11, t18);
			append(div11, div10);
			current = true;

			if (!mounted) {
				dispose = listen(div0, "click", /*click_handler*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*appRouter, parcoursArray*/ 2) {
				each_value = /*parcoursArray*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div5, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(ripple.$$.fragment, local);
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(ripple.$$.fragment, local);
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div1);
			destroy_component(ripple);
			destroy_component(sharebutton);
			if (detaching) detach(t3);
			if (detaching) detach(div11);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self) {
	const index = db.getIndex();

	// reverse order
	const parcoursArray = db.getAllParcours().slice().reverse();

	const click_handler = () => appRouter.show("/a_propos");
	const click_handler_1 = parcours => appRouter.show(`/parcours/${parcours.slug}`);
	return [index, parcoursArray, click_handler, click_handler_1];
}

class HomePage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default HomePage;